import React from 'react';
import { VetChatbot, VetChatbotProps } from '../../../../../../wag-react/components/chat-bot/components';
export type ChatbotMobileProps = VetChatbotProps;
export const ChatbotMobile = ({
  steps,
  ...rest
}: ChatbotMobileProps) => <VetChatbot isOpen steps={steps} {...rest} data-sentry-element="VetChatbot" data-sentry-component="ChatbotMobile" data-sentry-source-file="index.tsx" />;